<template>
  <div class="bottom-nav">
    <ul :class="navShow ? 'nav-box_show' : 'nav-box_hidden'">
      <li
        v-for="(item, index) in earthData"
        :key="index"
        :class="{ activeLi: iconSelect === 0 ? true : index == iconSelect }"
        @click="iconClick(index, item.mapType, item.sdescription)"
      >
        <div class="img-box">
          <img :src="item.img" alt="" />
          <span class="sky1 bgcolor"></span>
          <span class="sky2 bgcolor"></span>
        </div>
        <div class="bottom-sky"></div>
        <p>{{ item.stext }}</p>
      </li>
    </ul>
    <div class="bottom-switch">
      <img
        :class="navShow ? 'arrow-T' : 'arrow-B'"
        @click="setNavShow"
        src="../../../assets/index/arrow.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {},
    data() {
      return {
        earthData: [
          {
            stext: '全部',
            mapType: 'all',
            sdescription: '4',
            img: require('../../../assets/index/all.png'),
          },
          {
            stext: '监控',
            mapType: 'monitor',
            sdescription: '1',
            img: require('../../../assets/index/monitor.png'),
          },
          {
            stext: '闸机',
            mapType: 'gate',
            sdescription: '2',
            img: require('../../../assets/index/zhaji.png'),
          },
          {
            stext: '停车场',
            mapType: 'parkingLot',
            sdescription: '3',
            img: require('../../../assets/index/parkinglot.png'),
          },
          {
            stext: 'Wi-Fi',
            mapType: 'wifi',
            sdescription: '5',
            img: require('../../../assets/index/wifi.png'),
          },
          {
            stext: '广播',
            mapType: 'broadcast',
            sdescription: '6',
            img: require('../../../assets/index/radio.png'),
          },
          {
            stext: '事件',
            mapType: 'matter',
            sdescription: '7',
            img: require('../../../assets/index/event.png'),
          },
        ],
        iconSelect: 0,
        navShow: false,
      }
    },
    computed: {
      ...mapGetters({
        monitorList: 'map/monitorList',
      }),
    },
    watch: {
      monitorList(data) {
        if (data.length) {
          // 通知地图画点
          let obj = this.earthData[this.iconSelect]
          this.$store.dispatch('map/setClickslide', {
            name: obj.mapType,
            num: obj.sdescription,
          })
        }
      },
    },
    mounted() {
      this.navShow = true
      this.initAnime()
    },
    methods: {
      initAnime() {
        let anime = this.$animejs
        anime({
          targets: '.bottom-sky',
          scale: [0.8, 1],
          easing: 'linear',
          direction: 'alternate',
          loop: true,
        })
        anime({
          targets: '.img-box',
          translateY: -1,
          direction: 'alternate',
          loop: true,
          opacity: [0.8, 1],
          easing: 'linear',
        })
      },
      iconClick(i, name, num) {
        this.iconSelect = i
        this.$store.dispatch('map/setClickslide', { name, num })
      },
      // 显示/隐藏 nav
      setNavShow() {
        this.navShow = !this.navShow
      },
    },
  }
</script>

<style lang="scss" scoped>
  @mixin activeLi() {
    color: #f98721;
    .img-box {
      background: url('../../../assets/index/bg_active.png') no-repeat;
    }
    .bottom-sky {
      background: url('../../../assets/index/touying_a.png') no-repeat;
      background-size: 100% 100%;
    }
    .bgcolor {
      background: linear-gradient(0deg, rgba(47, 135, 245, 0) 0%, #f98721 100%);
    }
  }
  .bottom-nav {
    width: 80%;
    height: 150px;

    ul {
      display: flex;
      flex-direction: row;
      color: #10b177;
      transition: all 1s ease-in;
      li {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        // transition: all 1s ease-in;
        // &:hover {
        //   transform: rotateY(180deg);
        // }
        &:hover {
          @include activeLi;
          transform: scale(1.1);
        }
        // 光点
        .sky1 {
          left: 5px;
          bottom: 0;
          animation: smonth1 1.5s linear infinite;
        }
        .sky2 {
          right: 5px;
          bottom: -5px;
          animation: smonth1 2.5s linear infinite;
        }
        .bgcolor {
          background: linear-gradient(
            0deg,
            rgba(47, 135, 245, 0) 0%,
            #10ae77 100%
          );
          border-radius: 1px;
        }
      }
      .img-box {
        position: relative;
        border-radius: 50%;
        padding: 5px;
        display: flex;
        width: 52px;
        height: 52px;
        justify-content: center;
        align-content: center;
        background: url('../../../assets/index/bg_not.png') no-repeat;
        span {
          position: absolute;
          display: inline-block;
          height: 11px;
          width: 2px;
        }
      }
      .bottom-sky {
        width: 50px;
        margin: 4px auto;
        height: 13px;
        background: url('../../../assets/index/touying.png') no-repeat;
        background-size: 100% 100%;
      }
      .activeLi {
        @include activeLi;
      }
    }
  }
  // 整个nav 动画
  .nav-box_show {
    transform: translateY(0px) scale(1);
  }
  .nav-box_hidden {
    transform: translateY(300px) scale(0);
  }
  // 箭头
  .bottom-switch {
    position: absolute;
    left: -12%;
    bottom: 10px;
    width: 110%;
    background: url('../../../assets/index/switchBg.png') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    img {
      margin-left: -4%;
    }
    .arrow-T {
      transform: rotate(0);
    }
    .arrow-B {
      transform: rotate(180deg);
    }
  }
  @keyframes smonth1 {
    0% {
      opacity: 0.1;
      transform: translateY(10px);
    }
    50% {
      opacity: 1;
      transform: translateY(-5px);
    }
    100% {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
</style>
